import { Component, Vue, Emit } from 'vue-property-decorator';
// @ is an alias to /src
import { fetchSns } from '@/services/userService';
import store from '@/store';
import BoxSnsItem from '@/components/box/BoxSnsItem/BoxSnsItem.vue';
@Component({
  components: {
    BoxSnsItem,
  },
})
export default class HomeSNS extends Vue {
  private name = 'homesns';
  private list: SNS[] = [];
  get lang(): string {
    return store.getters['auth/lang'];
  }
  private mounted() {
    this.getList();
  }


  @Emit()
  private async getList() {
    const result = await fetchSns({
      lang: `${this.lang}`,
    })
    .then( (response) => {
      this.list = response;
      return true;
    })
    .catch( (e) => {
      console.error(e);
      return false;
    });
    return result;
  }
}
